module.exports = __webpack_public_path__ + "static/img/3.ebfd0c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/3.png
// module id = IGVv
// module chunks = 5